var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9654 11.1306C15.9742 12.1217 14.1091 12.0832 11.2494 12.0832C9.40958 12.0832 7.9179 10.5892 7.91695 8.74942C7.91695 5.89167 7.87842 4.02554 8.86967 3.03448C9.86083 2.04343 10.2987 2.08356 14.6896 2.08356C15.1139 2.08174 15.3275 2.59491 15.0275 2.89495L12.7667 5.15595C12.1928 5.72985 12.1912 6.66027 12.7652 7.2341C13.3391 7.80793 14.2696 7.80799 14.8436 7.23424L17.105 4.97379C17.4051 4.67382 17.9183 4.88736 17.9165 5.31162C17.9165 9.70183 17.9567 10.1396 16.9654 11.1306Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2499 12.0833L6.10693 17.2263C5.18647 18.1468 3.69408 18.1468 2.77361 17.2263C1.85313 16.3058 1.85313 14.8134 2.77361 13.893L7.91658 8.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59072 15.4167H4.58325",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceLight);
export default __webpack_public_path__ + "static/media/service_light.a31128cbc9a356f3876b17311d9f08aa.svg";
export { ForwardRef as ReactComponent };